import request from './request';
import deserialize from './deserialize';

type Image = {
  id: string;
  versions: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
};

export type Message = {
  id: string;
  createdAt: number;
  message: string;
  status: string;
  image?: Image;
  title: string;
  updatedAt: number;
  company: {
    id: string;
  };
  user: {
    id: string;
  };
};

export function get(messageId: string) {
  return request<Message>({
    url: `/api/v3/message/${messageId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function list() {
  return request<Message[]>({
    url: `/api/v3/messages`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function read(messageId: string) {
  return request<Message>({
    url: `/api/v3/message/${messageId}/read`,
    method: 'PUT',
    transformResponse: deserialize,
  });
}

export function archive(messageId: string) {
  return request<Message>({
    url: `/api/v3/message/${messageId}/archive`,
    method: 'PUT',
    transformResponse: deserialize,
  });
}
